import type { ComponentProps } from 'react'

import { cn } from '@/lib/utils'

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './select'

export type FilterSelectProps = {
  label: string
  value: string
  onChange: (value: string) => void
  items: Record<string, string>
  hideLabel?: boolean
  className?: string
  disabled?: boolean
} & Pick<ComponentProps<typeof SelectTrigger>, 'id' | 'ref' | 'onBlur' | 'aria-invalid' | 'aria-describedby'>

function FilterSelect({
  label,
  value,
  onChange,
  items,
  hideLabel,
  className,
  disabled,
  ...triggerProps
}: FilterSelectProps) {
  const select = (
    <Select
      value={value}
      onValueChange={(next) => {
        if (typeof next === 'string') onChange(next)
      }}
      items={items}
      disabled={disabled}
    >
      <SelectTrigger
        {...triggerProps}
        data-slot="filter-select"
        aria-label={label}
        className={cn('w-auto', className)}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {Object.entries(items).map(([itemValue, itemLabel]) => (
          <SelectItem key={itemValue} value={itemValue}>
            {itemLabel}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )

  if (hideLabel) return select

  return (
    <div className="flex flex-col gap-1 text-xs">
      <span className="text-muted-foreground">{label}</span>
      {select}
    </div>
  )
}

export { FilterSelect }
